import React from 'react';

import FieldString from '../../../components/plain/FieldString';
import FieldList_Strings from '../../../components/plain/FieldList_Strings';
import FieldList_MultilangString from '../../../components/plain/FieldList_MultilangString';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

class TabAAAbout extends React.Component {

	constructor(props) {
		super(props);
	}

	aboutCardBuilder = (fieldAbout, index) => {
		let card = '';
		if( fieldAbout.value.aboutName.value.length > 0 ) {
			card += fieldAbout.value.aboutName.value[0].value.value;
		}
		return card;
	}
	buildAboutPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<AboutPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain} readOnly={readOnly}
			/>
		);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_CardsPanel path={'/about'} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildAboutPanel} itemCardBuilder={this.aboutCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={true} readOnly={readOnly}
					readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '300px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class AboutPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'aboutDate'} parentField={fieldGroup} plain={plain}
						readOnly={readOnly}
							styles={{ input: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldList_MultilangString instance={instance} path={'aboutName'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldList_Strings instance={instance} path={'aboutUri'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'}}}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default TabAAAbout;